module.exports = __webpack_public_path__ + "static/img/9.70bc69b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/9.png
// module id = 2DqF
// module chunks = 4